import React, { useRef, useEffect, useState, useContext } from 'react';
import classNames from "./styles.module.scss"
import { Map, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import XYZ from 'ol/source/XYZ';
import 'ol/ol.css';
import { getMvtLayers } from '../../../shared/MvtLogicFunctios';
import Draw from 'ol/interaction/Draw';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import RegularShape from 'ol/style/RegularShape';
import Interaction from 'ol/interaction/Interaction';
import { sendMetricAction } from '../../../shared/MetricApi';
import { UserContext } from '../../../App';
import { useParams, useNavigate } from 'react-router-dom';
import { getCenterCoordinates } from '../../../shared/RKApi';
import { transform } from 'ol/proj';
import Overlay from 'ol/Overlay.js';
import VectorTileLayer from 'ol/layer/VectorTile';
import Exit from '../../../shared/icons/exitCross.svg'
import { SimpleGeometry } from 'ol/geom';
import { getCenter } from 'ol/extent';

interface Layerfilters {
  regions: boolean,
  municipals: boolean,
  settlement: boolean,
  cities: boolean,
  localities: boolean,
  streets: boolean,
  houses: boolean
}


const SelectedStyle = new Style({
  stroke: new Stroke({
    width: 3,
    color: "#00FF00"
  }),
  fill: new Fill({
    color: "#00FF0020"
  })
});


export const MapModule = (props: {
  setMap: Function,
  baseLayersContainer: any,
  onLayers: Layerfilters,
  setMapOpened: Function,
  mapOpened: boolean,
  drawEnabled: boolean,
  infoBlock: any,
  setContactState: Function
}) => {
  const mapElement = React.useRef<HTMLInputElement>(null)
  const mapRef = useRef<Map>();
  const [tiles, setTiles] = useState<any>({
    vectorLayerRegions: {},
    vectorLayerMunicipals: {},
    vectorLayerSettlement: {},
    vectorLayerCities: {},
    vectorLayerLocalities: {},
    vectorLayerStreets: {},
    vectorLayerHouses: {}
  })
  const [draw, setDraw] = useState<Interaction | undefined>()
  const [drawLayer, setDrawLayer] = useState<VectorLayer<VectorSource> | undefined>()
  const id = useContext(UserContext).id
  let { location } = useParams();
  const [locations, setLocations] = useState<[] | null>(null)
  const [featureClicked, setFeatureClicked] = useState<any>(null)
  const navigate = useNavigate()
  const [center, SetCenter] = useState<any>()

  const [territoryName, SetTerritoryName] = useState<string>('')
  const [selectedGuid, SetSelectedGuid] = useState<string>('')
  const [level, setLevel] = useState<number>(1)
  const [elementInfo, SetElementInfo] = useState<string>('')

  let remove = (map: Map, name: string) => {
    map && map?.getLayers().getArray().forEach(layer => {
      if (layer.get('name') === name) {
        map.removeLayer(layer)
      }
    })
  }

  let applyTemp = (map: Map) => {
    let tempLayer
    map && map?.getLayers().getArray().forEach(layer => {
      if (layer.get('name') === 'temp') {
        tempLayer = layer
      }
    })
    //@ts-ignore
    tempLayer && tempLayer.setVisible(true)
  }

  let hideSearch = (map: Map) => {
    map && map?.getLayers().getArray().forEach(layer => {
      if (layer.get('name') === 'temp') {
        layer.setVisible(false)
        // //@ts-ignore
        // layer.getSource()?.clear()
      }
    })
  }

  function stopDrawing(draw: Interaction | undefined, drawlayer: VectorLayer<VectorSource> | undefined) {
    draw && mapRef.current?.removeInteraction(draw)
    drawlayer && drawlayer.getSource()?.clear()
  }

  function check(map: Map, name: string) {
    let need = true
    map && map?.getLayers().getArray().forEach(layer => {
      if (layer.get('name') === name) need = false
    })
    return need
  }

  function isEmpty(obj: Object) {
    return Object.keys(obj).length === 0;
  }

  function infoByStats(stats: any) {
    let info = (stats.childs > 0 ? 'В этом элементе ' + stats.childs + ' элементов адресации, ' : '');
    info += stats.houses + ' зданий, из них геокодировано ' + stats.geocodedHouses + '.';
    info += ' ' + stats.hasOksCount + ' уже имеют связь с ОКС, еще для ' + stats.foundOksCount + ' можем ее найти' + (stats.houses > 0 ?
      '(' + Math.round(stats.hasOksCount / stats.houses * 100) + '% → ' + Math.round((stats.hasOksCount + stats.foundOksCount) / stats.houses * 100) + '%)'
      : '') + '.';

    return info;
  }

  useEffect(() => {
    getCenterCoordinates(setLocations)
  }, [])

  useEffect(() => {
    if (locations && locations.length > 0) {
      locations.forEach(loc => {
        //@ts-ignore
        if (loc.urlpart === location && mapRef.current) {
          setCenterFunction(loc)

          props.setMapOpened(true)
        }
      });
    }
    // eslint-disable-next-line
  }, [locations, location])

  function setCenterFunction(loc: any) {
    console.log('setCenterFunction')
    //@ts-ignore
    mapRef && mapRef.current.getView().setCenter(transform([loc.lon, loc.lat], 'EPSG:4326', 'EPSG:3857'));
    //@ts-ignore
    // mapRef.current.getView().setZoom(loc.zoom)
  }

  useEffect(() => {
    if (featureClicked && locations) {
      locations.forEach(loc => {
        //@ts-ignore
        if (loc.name === featureClicked.getGeometry().getProperties().territory_id) navigate('/product/fiasgeocoded/' + loc.urlpart + '/')
      })
    }
  }, [locations, featureClicked, navigate])

  useEffect(() => {
    if (featureClicked && id) {
      let title = ''
      if (featureClicked.getGeometry()) title = featureClicked.getGeometry().getProperties().territory_id
      sendMetricAction(id, 'featureClick', title)
    }
  }, [id, featureClicked])

  useEffect(() => {
    if (draw) {
      // mapRef.current.removeInteraction(draw)
      props.drawEnabled ? mapRef.current?.addInteraction(draw) : stopDrawing(draw, drawLayer)
    }
    // eslint-disable-next-line
  }, [props.drawEnabled])

  useEffect(() => {

    let applyLayer = (map: Map, layer: VectorLayer<VectorSource>, name: string) => {
      hideSearch(map)
      remove(map, 'selection')
      if (check(map, name)) {
        map.addLayer(layer)
      }
    }

    if (tiles && mapRef.current) {
      if (props.onLayers.regions && tiles.vectorLayerRegions.get)
        applyLayer(mapRef.current, tiles.vectorLayerRegions, 'RN_1_149')
      else
        remove(mapRef.current, 'RN_1_149')

      if (props.onLayers.municipals && tiles.vectorLayerMunicipals.get)
        applyLayer(mapRef.current, tiles.vectorLayerMunicipals, 'RN_1_150')
      else
        remove(mapRef.current, 'RN_1_150')

      if (props.onLayers.settlement && tiles.vectorLayerSettlement.get)
        applyLayer(mapRef.current, tiles.vectorLayerSettlement, 'RN_1_151')
      else
        remove(mapRef.current, 'RN_1_151')

      if (props.onLayers.cities && tiles.vectorLayerCities.get)
        applyLayer(mapRef.current, tiles.vectorLayerCities, 'RN_1_152')
      else
        remove(mapRef.current, 'RN_1_152')
      if (props.onLayers.localities && tiles.vectorLayerLocalities.get)
        applyLayer(mapRef.current, tiles.vectorLayerLocalities, 'RN_1_153')
      else
        remove(mapRef.current, 'RN_1_153')

      if (props.onLayers.streets && tiles.vectorLayerStreets.get)
        applyLayer(mapRef.current, tiles.vectorLayerStreets, 'RN_1_154')
      else
        remove(mapRef.current, 'RN_1_154')

      if (props.onLayers.houses && tiles.vectorLayerHouses.get)
        applyLayer(mapRef.current, tiles.vectorLayerHouses, 'RN_1_141')
      else
        remove(mapRef.current, 'RN_1_141')


      let allclosed = true
      for (var key in props.onLayers) {
        //@ts-ignore
        if (props.onLayers[key] === true) allclosed = false
      }
      allclosed && mapRef && applyTemp(mapRef.current)
      mapRef && mapRef.current.updateSize()
    }

  }, [tiles, props.onLayers, mapRef])

  useEffect(() => {
    let layers = getMvtLayers()
    layers.forEach(layer => {

      switch (layer.get('name')) {
        case 'RN_1_149':
          tiles.vectorLayerRegions = layer
          layer.setZIndex(5)
          break;

        case 'RN_1_150':
          tiles.vectorLayerMunicipals = layer
          layer.setZIndex(5)
          break;

        case 'RN_1_151':
          tiles.vectorLayerSettlement = layer
          layer.setZIndex(5)
          break;

        case 'RN_1_152':
          tiles.vectorLayerCities = layer
          layer.setZIndex(5)
          break;

        case 'RN_1_153':
          tiles.vectorLayerLocalities = layer
          layer.setZIndex(5)
          break;

        case 'RN_1_154':
          tiles.vectorLayerStreets = layer
          layer.setZIndex(5)
          break;

        case 'RN_1_141':
          tiles.vectorLayerHouses = layer
          layer.setZIndex(5)

          layer.setStyle((p) => {

            let color = [255, 255, 255, 0.7];

            if (p.getProperties().cadNum) {
              color = [0, 163, 204, 0.4];
            }
            if (p.getProperties().cadNumFound) {
              color = [40, 174, 0, 0.4];
            }

            return new Style({
              stroke: new Stroke({
                color: "#6666F9",
                width: 1
              }),
              fill: new Fill({
                color: color
              }),
            })
          });

          break;

        default:
          break;
      }

      setTiles(tiles)

    })
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    let center2 = [5584030.684758671, 7021364.820491779]
    let getCoords = async () => {
      let showPosition = (position: { coords: { latitude: any; longitude: any; }; }) => {
        if (position) {
          center2 = [position.coords.latitude, position.coords.longitude]
          SetCenter(transform([center2[1], center2[0]], 'EPSG:4326', 'EPSG:3857'))
        }
      }
      await navigator?.geolocation?.getCurrentPosition(showPosition);

      SetCenter([center2[0], center2[1]])
    }
    getCoords()
  }, [])

  useEffect(() => {

    let baseLayer = props.baseLayersContainer && props.baseLayersContainer.find((baseLayer: any) => baseLayer.turned);
    let baseId = baseLayer && baseLayer.id;

    //@ts-ignore
    mapRef && mapRef.current && mapRef.current.getLayers().getArray().forEach(layer => {

      if (layer.get('name').includes('-base')) {
        if (layer.get('name') !== baseId+'-base') {
          layer.setVisible(false)
        }
        else layer.setVisible(true)
      }
    })

  }, [mapRef, props.baseLayersContainer])

  useEffect(() => {

    if (mapElement.current && !mapRef.current && center) {

      const osmLayer = new TileLayer({
        preload: Infinity,
        source: new OSM(),
        visible: true,
      })
      osmLayer.set('name', 'osm-base')

      const eecoLayer = new TileLayer({
        preload: Infinity,
        source: new XYZ({ url: "https://rk.geosamara.ru/api/aeggis/v2/235/wmts/{z}/{x}/{y}.png" }
        ),
        visible: false,
      })
      eecoLayer.set('name', 'eeco-base')

      const satelliteLayer = new TileLayer({
        preload: Infinity,
        source: new XYZ({ url: "https://rk.geosamara.ru/api/aeggis/v2/36338/wmts/{z}/{x}/{y}.png" }
        ),
        visible: false,
      })
      satelliteLayer.set('name', 'satellite-base')

      const sourceDraw = new VectorSource({ wrapX: false });
      const sourceTemp = new VectorSource({ wrapX: false });

      const vectorDraw = new VectorLayer({
        source: sourceDraw,
        zIndex: 99,
        style: new Style({
          stroke: new Stroke({
            color: "black",
            width: 3
          }),
          fill: new Fill({
            color: [255, 255, 255, 0]
          }),
        })
      });

      const vectorTemp = new VectorLayer({
        source: sourceTemp,
        zIndex: 100,
        style: new Style({
          stroke: new Stroke({
            color: "#6666F9",
            width: 3
          }),
          fill: new Fill({
            color: [255, 255, 255, 0.7]
          }),
        })
      });

      vectorDraw.set('name', 'draw')
      vectorTemp.set('name', 'temp')

      const container = document.getElementById('popup');

      let elem = container ? container : null
      const overlay = new Overlay({
        //@ts-ignore
        element: elem,
        id: 'popuping',
        position: undefined,
        autoPan: {
          animation: {
            duration: 250,
          },
        },
      });

      mapRef.current = new Map({
        target: mapElement.current ? mapElement.current : undefined,
        layers: [osmLayer, eecoLayer, satelliteLayer, vectorTemp],
        overlays: [overlay],
        view: new View({
          center: center,
          zoom: 5,
        })
      });

      mapRef.current.addEventListener('click', (e: any) => {
        let drawing = false
        let layers:any = []
        e.map.getInteractions().getArray().forEach((inter: any) => {
          if (inter.get('name') === 'draw') drawing = true
        });
        if (!drawing) {
          const pixel = e.map.getEventPixel(e.originalEvent);

          let features: any[] = []

          e.map.forEachFeatureAtPixel(pixel, function (feature: any, layer: any) {
            if(layer.getVisible()) {
              features.push(feature)
              layers.push(layer)
            }
          });

          if (features.length > 0) {
            setFeatureClicked(features[0]);
            if (features[0].get('geomApi'))
            {
              SetElementInfo("...")
              let info = features[0].get('geomApi');
              if (info) {
                let infoFooter = (info.cadNum ? 'Связан с ОКС: ' + info.cadNum :
                  (info.cadNumFound ? 'Можно найти связь с ОКС' :
                    'Связь с ОКС не установлена')
                );
                SetTerritoryName(info.name + ' ' + (info.typename ? (info.typename) : ''))
                SetSelectedGuid(info.guid)
                let infoString = '';
                infoString += info.parents.map((item:any) => item.name).join(', ');

                infoString += (info.stats ? '. ' + infoByStats(info.stats) : '');
                SetElementInfo(infoString+'\n'+infoFooter);
              }
            }
            else
            {
              const newLevel = Number(features[0].properties_.level);
              setLevel(!Number.isNaN(newLevel) ? newLevel : 1);

              SetElementInfo("...")
              if (features[0].properties_ && !isEmpty(features[0].properties_)) {
                if (features[0].properties_.HouseNumber) {
                  SetTerritoryName(features[0].properties_.Municipalitet + ', ' + features[0].properties_.Street + ', ' + features[0].properties_.HouseNumber)
                  SetSelectedGuid(features[0].properties_.ID)

                  let info = (features[0].properties_.cadNum ? 'Связан с ОКС: ' + features[0].properties_.cadNum :
                    (features[0].properties_.cadNumFound ? 'Можно найти связь с ОКС' :
                      'Связь с ОКС не установлена')
                  );
                  SetElementInfo(info)

                }
                else {
                  SetTerritoryName(features[0].properties_.prettyName)
                  SetSelectedGuid(features[0].properties_.GUID)

                  if (features[0].properties_.stats) {
                    let stats = JSON.parse(features[0].properties_.stats);
                    SetElementInfo(infoByStats(stats));
                  }
                  setLevel(parseInt(features[0].properties_.level));
                }
              }
            }

            mapRef.current?.getOverlayById('popuping').setPosition(e.coordinate);
            mapRef.current?.getView().setCenter(e.coordinate)
          }
        }
      })

      let draw = new Draw({
        source: sourceDraw,
        type: "Polygon",
        style: new Style({
          stroke: new Stroke({
            color: "black",
            width: 3
          }),
          fill: new Fill({
            color: [255, 255, 255, 0]
          }),

          image: new RegularShape({
            fill: new Fill({ color: 'black' }),
            stroke: new Stroke({ color: 'black', width: 1 }),
            points: 100,
            radius: 5,
            rotation: 0,
            angle: 0
          }),
        })
      });
      draw.on('drawend', function (e) {
        props.setContactState(true)
      });

      draw.on('drawstart', function (e) {
        sourceDraw && sourceDraw.clear()
      });

      draw.set('name', 'draw')
      setDraw(draw)
      setDrawLayer(vectorDraw)
      props.setMap(mapRef)
    }
    //eslint-disable-next-line
  }, [mapElement, mapRef, center]);

  useEffect(() => {
    if (props.infoBlock && mapRef && mapRef.current)
    {
      SetElementInfo("...")
      let info = props.infoBlock.feature.get('geomApi');
      if (info) {
        let infoFooter = (info.cadNum ? 'Связан с ОКС: ' + info.cadNum :
          (info.cadNumFound ? 'Можно найти связь с ОКС' :
            'Связь с ОКС не установлена')
        );
        SetTerritoryName(info.name + ' ' + (info.typename ? (info.typename) : ''))
        SetSelectedGuid(info.guid)
        let infoString = '';
        infoString += info.parents.map((item:any) => item.name).join(', ');

        infoString += (info.stats ? '. ' + infoByStats(info.stats) : '');
        SetElementInfo(infoString+'\n'+infoFooter);
      }

      let geom = props.infoBlock.feature.get('geometry');
      if (geom)
      {
        const extent = (geom as SimpleGeometry).getExtent();
        if (extent)
        {
          const overlay = mapRef.current?.getOverlayById("popuping");
          overlay && overlay.setPosition(getCenter(extent));
        }
      }
    }
  }, [props.infoBlock])

  function download() {
    props.setContactState(true, territoryName)
    id && sendMetricAction(id, 'saveButtonClick', territoryName)
    const overlay = mapRef.current?.getOverlayById("popuping");
    overlay && overlay.setPosition(undefined);
  }

  return (
    <>
      <div id="popup" className={classNames['ol-popup'] + ' ' + classNames.infoFeatureDisplayer}>
        <div id='popup-content' className={classNames.infoContainer + ' ' + classNames.opened}>
          {elementInfo &&<div className={classNames.titleContainer}>
            <div className={classNames.cityElement}>
              <p className={classNames.cityTitle}>
                <a href={"https://xn--80ap2aj.xn--80asehdb/" + selectedGuid} rel="noreferrer" target="_blank">{territoryName}</a>
              </p>
            </div>
            <div className={classNames.infoButton}><img id="exitPopup" className={classNames.exit} alt="close icon" src={Exit} onClick={() => {
              const overlay = mapRef.current?.getOverlayById("popuping");
              overlay && overlay.setPosition(undefined);
            }} /></div>
          </div>}

          <div key={'line'} className={classNames.infoElement}>
            <p className={classNames.infoTitle}>{elementInfo}</p>
          </div>

          {(level <= 6) &&
            <div id='lineDownload' key={'lineDownload'} className={classNames.downloadElement} onClick={() => { download() }} >
              <div className={classNames.save}><p >Скачать</p></div>
            </div>
          }

        </div>
      </div>
      <div ref={mapElement} style={{ pointerEvents: props.mapOpened ? 'unset' : 'none' }} className={classNames.map} />
    </>
  );

}


